


































import { Subscription, FormStep } from 'inscreva-sse-models';
import moment from 'moment';
import SortTable, {
  SortBy,
  FilterBy,
  ListBody,
  ColumnHeader,
  ListHeader,
  FilterableHeader,
} from 'ss-commons-front/src/components/SortTable.vue';
import Multiselect from 'vue-multiselect';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { stringFormatter } from '../models/utils';
import { sessionStore } from '../store/session';

@Component({
  components: {
    SortTable,
    Multiselect,
  },
})
export default class SubscriptionListComponent extends Vue {
  @Prop({ required: true })
  private subscriptions: Array<Subscription>;

  @Prop({ required: true })
  private subscriptions_filtered: Array<Subscription>;

  @Prop({ required: true })
  private sortBy!: SortBy<Subscription>;

  @Prop({ required: true })
  private filterBy!: FilterBy<Subscription>;

  @Prop({ required: true })
  eventExtraFields: { text: string; key: string }[];

  private filter = {
    key: '',
    value: '',
  };

  private onVisualize(subscription: Subscription) {
    this.$emit('on-visualize', subscription);
  }

  private onActiveStatusChange(subscription: Subscription) {
    this.$emit('on-activeStatus', subscription);
  }

  private onRemove(subscription: Subscription) {
    this.$emit('on-remove', subscription);
  }

  private sortList(sortBy: SortBy<Subscription>) {
    this.$emit('sort-list', sortBy);
  }

  private filterList(filterBy: FilterBy<Subscription>) {
    this.$emit('filter-list', filterBy);
  }

  get column_headers(): Array<ColumnHeader<Subscription>> {
    return [{ text: '#' }, ...this.row_headers, { text: '' }];
  }

  get row_headers(): Array<ListHeader<Subscription>> {
    return [
      { text: 'Nome', key: 'nome' },
      { text: 'E-mail', key: 'email' },
    ].concat(
      this.eventExtraFields,
      { text: 'Data', key: 'createdAtFormatted' },
      this.includes_cidade
        ? [{ text: 'Cidade', key: 'cidade', allowFiltering: true } as FilterableHeader<Subscription>]
        : [],
    );
  }

  get includes_cidade(): boolean {
    return !!(sessionStore.session.event?.steps.find(({ type }) => type === 'form') as FormStep)?.form.fields.find(
      (elm) => elm.id === 'cidade',
    );
  }

  get row_headers_key(): Array<string> {
    return this.row_headers.map(({ key }) => key);
  }

  private filterValuesFromHeader(header: FilterableHeader<Subscription>): Array<string> {
    const groupedKeys = this.subscriptions.reduce((groupedKeys: any, value: any) => {
      groupedKeys[stringFormatter(value[header.key] || '', true)] = value;
      return groupedKeys;
    }, {});
    return Object.keys(groupedKeys);
  }

  get body(): ListBody<Subscription> {
    return {
      values: this.subscriptions_filtered.map((subs) => ({
        ...subs,
        createdAtFormatted: moment(subs.createdAt).format('DD/MM/YYYY HH:mm'),
      })),
      row_headers: this.row_headers,
      rowButtons: {
        buttons: [
          {
            id: 'visualize',
            text: '',
            label: 'Visualizar',
            icon: {
              class: 'fas fa-eye',
            },
            class: 'btn-outline-success',
          },
          {
            id: 'activeStatus',
            text: '',
            label: (subscription: Subscription) => (subscription.active === false ? 'Ativar' : 'Inativar'),
            icon: {
              class: (subscription: Subscription) => `fas fa-${subscription.active === false ? 'plus' : 'ban'}`,
            },
            class: 'btn-outline-primary',
          },
          {
            id: 'remove',
            text: '',
            label: 'Remover',
            icon: {
              class: 'fas fa-trash',
            },
            class: 'btn-outline-danger',
          },
        ],
      },
    };
  }
}
